import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation AssignAgentAccess($assignments: [AccessAssignment!]!) {
    assignAccess(assignments: $assignments)
  }
`

const TRANSFORMER = graphql.transformers.OUT.nullable(
  graphql.transformers.OUT.select<
    graphql.schema.AssignAgentAccessMutation,
    boolean | undefined,
    'assignAccess'
  >('assignAccess', transformers.PASS_THROUGH),
)

export const executor = graphql.createExecutor<
  graphql.schema.AssignAgentAccessMutation,
  boolean | undefined,
  graphql.schema.AssignAgentAccessMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
